import React from "react";
import { Droplet } from "lucide-react";
import { useTranslation } from "react-i18next";
import { getSensorDepths } from "../../utils/sensorDepths";
import "./SoilMoistureLevels.css";

export const soilMoistureNumber = (value) => {
  if (value === null || value === undefined || String(value).trim() === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export default function SoilMoistureLevels({ reading = {}, sensorDepths }) {
  const { t } = useTranslation();
  const depths = getSensorDepths(sensorDepths);
  return (
    <div className="sf-soil-levels" role="group" aria-label={t("humidity_percent_full")}>
      {["mv1", "mv2", "mv3"].map((key) => {
        const value = soilMoistureNumber(reading[key]);
        return (
          <div className="sf-soil-level" key={key}>
            <span className="sf-soil-level-depth">{depths[key]} cm</span>
            <div className="sf-soil-level-track" aria-hidden="true">
              {value !== null && (
                <span className="sf-soil-level-marker" style={{ left: `${Math.max(0, Math.min(100, value))}%` }}>
                  <Droplet size={12} fill="currentColor" strokeWidth={1.5} />
                </span>
              )}
            </div>
            <strong className="sf-soil-level-value">{value === null ? "—" : `${value.toFixed(1)}%`}</strong>
          </div>
        );
      })}
      <div className="sf-soil-level-legend">
        <span>{t("Critical")}</span>
        <span>{t("Optimal")}</span>
        <span>{t("Full")}</span>
      </div>
    </div>
  );
}
